<form>
    <section mat-dialog-title>
        <button mat-dialog-close mat-icon-button matTooltip="Close.">
            <mat-icon>close</mat-icon>
        </button>
        <h1>
            <mat-icon>delete</mat-icon>
            Delete user account
        </h1>
    </section>
    <section mat-dialog-content="">
        <h2>
            Are you sure you want to delete {{data.first_name}} {{data.last_name}}'s account? This action cannot be
            undone.
        </h2>
    </section>
    <section align="end" mat-dialog-actions>
        <button mat-button mat-dialog-close matTooltip="Cancel and close." type="button">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-button matTooltip="Delete account." type="button" (click)="confirm(data)">
            <mat-icon>confirm</mat-icon>
            Confirm
        </button>
    </section>
</form>